<template>
  <section class="article-container">
    <template v-if="true">
      <section class="swiper">
        <!-- <img :src="articleData.article_pic_syn" /> -->
        <img :src="swiper" />
        <!-- <p>{{ data.swiperText }}</p> -->
      </section>
      <div class="container">
        <!-- <ul class="nav">
          <li v-for="item in data.menus" :key="item.menu2Id" :class="{ active: item.menu2Id == menu2Id }" @click="handleToColumn">{{ item.article_pdf_syn
            }}</li>
        </ul> -->
        <div class="main">
          <div class="main-t"><h3>{{ articleData.article_title }}</h3></div>
          <div class="time">
            <span v-if="articleData.create_at"><span class="bold">Release Time</span>：{{ articleData.create_at }}</span>
            <span v-if="articleData.article_autor"><span class="bold">Author：</span>{{ articleData.article_autor }}</span>
            <span v-if="articleData.article_view_count"><span class="bold">Number of article previews：</span>{{ articleData.article_view_count }}</span>
          </div>
          <div class="content" v-html="articleData.article_content">
          </div>
          <div v-if="articleData.article_pdf_syn"
            style="width: 1200px; margin: 0 auto;"
          >
            <pdf
              v-for="item in pdfNum"
              :key="item"
              :page="item"
              style="width: 100%"
              :src="articleData.article_pdf_syn"></pdf>
          </div>
          <!-- <a v-if="articleData.article_pdf_syn" style="color: #409eff;cursor: pointer" :href="articleData.article_pdf_syn" target="__blank" >PDF Download</a> -->
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { getOneMenu } from '@/api/column';
import { frontGetArticle } from '@/api/api';
import pdf from 'vue-pdf';

export default {
  components: { pdf },
  data() {
    return {
      memu1Id: undefined,
      memu2Id: undefined,
      articleId: undefined,
      data: {},
      swiper: require("@/assets/temp/main_lx_bg.png"),
      articleData: {},
      pdfNum: 0
    }
  },
  created() {
    const { memu1Id, memu2Id, articleId } = this.$route.query;
    this.memu1Id = memu1Id;
    this.memu2Id = memu2Id;
    this.getPageData(memu1Id, memu2Id)
    this.getArticleData(articleId);
  },
  methods: {
    getPdfNum(pdfUrl) {
      const pdfSrc = pdf.createLoadingTask({ url: pdfUrl });
      pdfSrc.promise.then(pdf => {
        console.log(pdf, pdf.numPages)
        this.pdfNum = pdf.numPages;
      })
    },
    getArticleData(articleId) {
      frontGetArticle({
        articleId
      }).then(res => {
        const data = res.data;
        console.log(data.article_content)
        data.article_content = data.article_content.replaceAll('/wb_smu/JDiy_data', process.env.VUE_APP_RESOURCE + '/JDiy_data')
        if(data.article_pdf_syn) {
          data.article_pdf_syn = process.env.VUE_APP_RESOURCE + data.article_pdf_syn;
          this.getPdfNum(data.article_pdf_syn);
        }
        this.articleData = data;
        console.log(res)
      })
    },
    getPageData(memu1Id, memu2Id) {
      // getOneMenu(memu1Id).then(res => {
      //   this.data = res.data;
      //   // this.swiper =  //this.data.swiper;
      // })
    },
    handleToColumn() {
      this.$router.push({
        path: `/column?menu_id=${this.menu1Id}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.article-container {
  .swiper {
    position: relative;

    img {
      display: block;
      width: 100%;
    }

    p {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 300px;
      width: 1500px;
      text-align: center;
      font-size: 48px;
      font-weight: 700;
      color: #fff;
    }
  }

  .content {
    font-size: 14px;;
  }

  .container {
    padding: 36px 0 20px;
    display: flex;
    width: 1500px;
    margin: 0 auto;

    .nav {
      margin-right: 30px;
      width: 218px;

      li {
        width: 218px;
        height: 50px;
        color: #fff;
        text-align: center;
        /* margin-bottom: 10px; */
        margin-bottom: 16px;
        line-height: 50px;
        background-color: #b41184;
        cursor: pointer;

        &.active,
        &:hover {
          background-color: #2c3e50
        }
      }
    }

    .main {
      flex: 1;

      .main-t {
        text-align: center;
      }
      h3 {
        text-align: center;
        width: 100%;
        font-size: 2em;
        color: #2c3e50;
        border-bottom: 1px solid #999;
        padding-bottom: 10px;
        margin-top: 36px;
        margin-bottom: 20px;
      }

      .time {
        text-align: center;
        color: rgb(153, 153, 153);
        margin-bottom: 36px;
        >span {
          margin-right: 24px;
        }
        .bold {
          font-weight: 700;
        }
      }

      p {
        margin-bottom: 0 !important;
        line-height: 1.2em !important;
        // text-align: justify;
        text-indent: 2em;
        color: #4f4f4f;
        font-size: 14px;
      }
    }
  }
}
</style>
